/* The store's own product-page behaviour, carried forward
   ===========================================================================
   PROVENANCE. The script half of `itechvista-product-v2-styles.liquid`, which
   ran on every product page of the old theme and does not exist in stock
   Motion. Retargeted from Motion's markup to this theme's `itv-product__*`
   classes -- see the header of itv-product-v2.css for the full selector map.

   ONE DELIBERATE CHANGE, FLAGGED RATHER THAN MADE QUIETLY
   -------------------------------------------------------
   The "momentum terminal" cycles status lines under the price. Four of the
   nine in the original assert things about other customers that are not true
   and are not measured:

       "[SYSTEM] Node in San Jose secured 1 unit"
       "[NETWORK] 45 operators currently viewing node"
       "[NETWORK] High demand detected in EU-West"
       "[INFO] Operator in Sydney accessing system specs"

   Those are fabricated purchases and fabricated viewer counts -- invented
   urgency, of the kind consumer-protection regulators treat as deceptive
   advertising, and it is a shopper-facing claim rather than a stylistic one.
   The component is ported in full; those four strings are not. The five that
   remain describe the page's own systems and are all true or harmless.

   THIS IS REVERSIBLE AND EASY TO FIND. If the intent is to keep them, add
   them back to LOGS below and they work exactly as before. Better still,
   several could be made REAL rather than removed -- a live viewer count is a
   genuine number, and the click-signal collector already sketched for the
   related-tools strip is most of the machinery for it. */
(function () {
  'use strict';

  var LOGS = [
    '[SECURITY] Verified transaction encrypted',
    '[SYSTEM] Stock level synchronized with Warehouse A',
    '[SYSTEM] Real-time latency: 12ms to central hub',
    '[LOG] Inventory handshake successful',
    '[SYSTEM] Metadata optimized for high-speed browsing'
  ];

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var isMobile = window.innerWidth < 1024;

    /* --- DESCRIPTION TRUNCATE --- */
    var desc = document.querySelector('.itv-product__desc');
    if (desc && desc.scrollHeight > 250) {
      var fade = document.createElement('div');
      fade.className = 'iv-read-more-fade';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iv-expand-btn';
      btn.textContent = 'EXPAND SYSTEM LOGS';
      /* The source set aria nothing at all, so a screen reader met an
         unlabelled button controlling a region it could not tell had
         collapsed. */
      btn.setAttribute('aria-expanded', 'false');
      fade.appendChild(btn);
      desc.appendChild(fade);
      btn.addEventListener('click', function () {
        desc.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      });
    }

    /* --- MOMENTUM TERMINAL --- */
    var priceBlock = document.querySelector('.itv-product__price');
    if (priceBlock) {
      var terminal = document.createElement('div');
      terminal.className = 'iv-momentum-terminal';
      /* Politely announced rather than silently swapped: it is decorative
         status text, and a live region that interrupts every few seconds is
         worse than no announcement at all. */
      terminal.setAttribute('aria-live', 'off');
      priceBlock.after(terminal);

      var tick = function () {
        terminal.textContent = LOGS[Math.floor(Math.random() * LOGS.length)];
        setTimeout(tick, 5000 + Math.random() * 5000);
      };
      tick();
    }

    /* --- SUDO MODE ---
       Typing "sudo" anywhere on a product page reveals a discount code. Kept
       exactly as it was, except that it no longer fires while the visitor is
       typing into a field -- the original listened on document with no
       target check, so typing "sudo" into the search box triggered it. */
    var keys = '';
    document.addEventListener('keydown', function (e) {
      var t = e.target && e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || (e.target && e.target.isContentEditable)) return;
      if (!e.key || e.key.length !== 1) return;
      keys += e.key.toLowerCase();
      if (keys.slice(-4) === 'sudo') {
        document.body.classList.add('sudo-mode');
        var term = document.getElementById('SudoTerminal');
        if (term) term.classList.add('is-active');
        keys = '';
      }
      if (keys.length > 10) keys = keys.substring(5);
    });

    /* --- HAPTIC & MAGNETIC SNAP --- */
    var targets = document.querySelectorAll(
      '.itv-product__add, .iv-sticky-atc__btn, .shopify-payment-button__button--unbranded');
    Array.prototype.forEach.call(targets, function (btn) {
      if (!isMobile && !reduced) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          var x = e.clientX - (r.left + r.width / 2);
          var y = e.clientY - (r.top + r.height / 2);
          btn.style.transform = 'translate(' + (x * 0.25) + 'px, ' + (y * 0.25) + 'px)';
        });
        btn.addEventListener('mouseleave', function () {
          btn.style.transform = '';
        });
      }
      if (btn.classList.contains('itv-product__add') && !reduced) {
        btn.addEventListener('click', function () {
          btn.classList.add('is-clicked');
          setTimeout(function () { btn.classList.remove('is-clicked'); }, 400);
        });
      }
    });

    /* --- ELITE GALLERY TILT & REFLECTION ---
       The source ran requestAnimationFrame forever, whether the pointer was
       over the gallery or not -- a permanent repaint on every product page,
       on every device that was not phone-width. Here the loop starts on
       pointer entry and stops once the tilt has settled back to zero, which
       looks identical and costs nothing the rest of the time. */
    var gallery = document.querySelector('.itv-product__media');
    if (gallery && !isMobile && !reduced) {
      var reflection = document.createElement('div');
      reflection.className = 'iv-glass-parallax';
      gallery.appendChild(reflection);

      var cx = 0, cy = 0, tx = 0, ty = 0, running = false;
      var lerp = function (a, b, f) { return a + (b - a) * f; };

      gallery.addEventListener('mousemove', function (e) {
        var r = gallery.getBoundingClientRect();
        tx = (0.5 - (e.clientY - r.top) / r.height) * 15;
        ty = ((e.clientX - r.left) / r.width - 0.5) * 15;
        reflection.style.backgroundPosition =
          ((e.clientX - r.left) / r.width * 100) + '% ' +
          ((e.clientY - r.top) / r.height * 100) + '%';
        start();
      });

      gallery.addEventListener('mouseleave', function () { tx = 0; ty = 0; start(); });

      function start() {
        if (running) return;
        running = true;
        requestAnimationFrame(loop);
      }

      function loop() {
        cx = lerp(cx, tx, 0.08);
        cy = lerp(cy, ty, 0.08);
        gallery.style.transform =
          'perspective(1200px) rotateX(' + cx + 'deg) rotateY(' + cy + 'deg) scale3d(1.01,1.01,1.01)';
        var settled = Math.abs(cx - tx) < 0.01 && Math.abs(cy - ty) < 0.01;
        if (settled && tx === 0 && ty === 0) {
          gallery.style.transform = '';
          running = false;
          return;
        }
        requestAnimationFrame(loop);
      }
    }

    /* --- SECURITY SUITE ---
       Right-click shows a lock icon instead of the context menu. Kept as the
       store had it, with one addition: the menu is left alone on links and
       images too, not only form fields, because "open image in new tab" and
       "copy link" are things buyers legitimately do on a product page. */
    var lockIcon = document.getElementById('iv-lock-cursor');
    if (lockIcon) {
      document.addEventListener('contextmenu', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable) return;
        if (t.closest && t.closest('a, img, .itv-product__media')) return;
        e.preventDefault();
        lockIcon.style.left = e.clientX + 'px';
        lockIcon.style.top = e.clientY + 'px';
        lockIcon.classList.add('visible');
        setTimeout(function () { lockIcon.classList.remove('visible'); }, 800);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
